import { GlobalHelper } from "../../../../../indexImports"
import {
    HandlePriceChangePayload, initializePayload,
    UpdatePayload
} from "../actions/productPriceActions"
import { State } from "./productPriceReducer"


export const ProductPricesHandler = (state: State) => {
    let priceLevelId = ""
    return {
        initialize(payload: initializePayload):State {
            const sortedArray = Array.from(payload.displayedProductPrices.entries()).sort((a, b) =>
                GlobalHelper.sortStringField(a[1].name, b[1].name, true)
            )
            const sortedMap = new Map(sortedArray)
            return {
                ...state,
                displayedProductPrices: sortedMap
            }
        },

        addPrice(payload: UpdatePayload) {
            priceLevelId = payload.priceLevelId
            const productPriceToAdd = state.displayedProductPrices.get(priceLevelId)
            if (!productPriceToAdd){
                return state
            }
            
            const newProductPrice = { ...productPriceToAdd, price: "0.00", recentlyModified: true, isArchived:false }
            const newProdPriceMap = new Map(state.displayedProductPrices)
            newProdPriceMap.set(priceLevelId, newProductPrice)            
            return {
                ...state,
                displayedProductPrices: newProdPriceMap,
            }
        },

        removePrice(payload: UpdatePayload) {
            priceLevelId = payload.priceLevelId
            const productPriceToRemove = state.displayedProductPrices.get(priceLevelId)
            if (!productPriceToRemove) {
                return state
            }
 
            const removedProductPrice = {...productPriceToRemove, toBeArchived: true, price: "", recentlyModified: true, isArchived:true }
            const removedProdPriceMap = new Map(state.displayedProductPrices)
            removedProdPriceMap.set(priceLevelId, removedProductPrice) 
            return {
                ...state,
                displayedProductPrices: removedProdPriceMap,
            }
        },

        handlePriceChange(payload: HandlePriceChangePayload) {
            priceLevelId = payload.priceLevelId
            const productPriceToUpdate = state.displayedProductPrices.get(priceLevelId)
            if (!productPriceToUpdate) {
                return state
            }
            const priceNumber = Number(payload.newPrice) 
            if ((priceNumber === 0)) { 
                return state
            }
            
            const newPrice = payload.newPrice
            const productPriceChanged = {
                ...productPriceToUpdate,
                price: newPrice.toString(),
                recentlyModified: true
            }
    
            const updatedProdPriceMap = new Map(state.displayedProductPrices)
            updatedProdPriceMap.set(priceLevelId, productPriceChanged)       
            return {
                ...state,
                displayedProductPrices:updatedProdPriceMap,
            }
        },
    }
}


// WEBPACK FOOTER //
// ./src/product/form/components/states/reducers/productPriceHandler.ts